/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Maria_Ward_Schule_Badhomburg5Inputs */

const en__field_enum_maria_ward_schule_badhomburg5 = /** @type {(inputs: _Field_Enum_Maria_Ward_Schule_Badhomburg5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bad Homburg`)
};

const de__field_enum_maria_ward_schule_badhomburg5 = /** @type {(inputs: _Field_Enum_Maria_Ward_Schule_Badhomburg5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maria-Ward-Schule`)
};

/**
* | output |
* | --- |
* | "Bad Homburg" |
*
* @param {_Field_Enum_Maria_Ward_Schule_Badhomburg5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_maria_ward_schule_badhomburg5 = /** @type {((inputs?: _Field_Enum_Maria_Ward_Schule_Badhomburg5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Maria_Ward_Schule_Badhomburg5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_maria_ward_schule_badhomburg5(inputs)
	return de__field_enum_maria_ward_schule_badhomburg5(inputs)
});
export { _field_enum_maria_ward_schule_badhomburg5 as "_field_enum_Maria_Ward_Schule_BadHomburg" }